export const Steps = (() => {
	'use strict';

	function init() {

			var $link = $('.step__number');

			$link.on('click', function (event) {
				event.preventDefault();
			
				$('html, body').animate({
					scrollTop: $($.attr(this, 'href')).offset().top - 100
				}, 500);
			});
		
	}

	return {
		init: init,
		name: 'steps'
	};
})();
